import React, { PropsWithChildren } from 'react'
import './index.scss'

const CompactWorkItemHeader = ({ children }: PropsWithChildren) => (
    <div className="compact-work-header">
        <div>Song Title</div>
        <div>MLC Song Code</div>
        <div>Writers</div>
        <div>{children}</div>
    </div>
)

export default CompactWorkItemHeader
